import { Typography, julo } from '@julo-ui/react';

import searchIcon from 'assets/icons/ic-search-blue.svg';

import { newApplicationAlert } from './styles';

interface Props {
  message: string;
}

const NewApplicationAlert = (props: Props) => {
  const { message } = props;

  return (
    <julo.div className={newApplicationAlert}>
      <julo.img src={searchIcon} alt='search icon' />
      <Typography type='caption'>{message}</Typography>
    </julo.div>
  );
};

export default NewApplicationAlert;
